import React, { useState, useEffect, useCallback } from "react";
import { Link, useParams, Redirect, useHistory } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  FormGroup,
  Card,
  CardBody,
  Spinner,
  Button,
} from "reactstrap";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";

import { useDispatch, useSelector } from "react-redux";

import {
  getProfile,
  createProfile,
  editProfile,
  resetProfiles,
} from "../../store/profiles/actions";

const NewProfile = ({ t }) => {
  let { idProfile } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();

  const {
    dataProfile,
    loadingProfile,
    successProfile,
    errorProfile,
  } = useSelector((state) => state.Profile);

  const [name, setName] = useState("");
  const [role, setRole] = useState("");
  const [description, setDescription] = useState("");

  const [newProfileValues, setNewProfileValues] = useState({});

  const [textAreaBadge, setTextAreaBadge] = useState(false);
  const [textCount, setTextCount] = useState(false);

  const textareachange = (event) => {
    var data = event.target.value;
    var count = data.length;

    if (count > 0) {
      setTextAreaBadge(true);
    } else {
      setTextAreaBadge(false);
    }

    setTextCount(data.length);
    setDescription(event.target.value);
    setNewProfileValues({
      ...newProfileValues,
      description: event.target.value,
    });
  };

  const optionsRole = () => {
    let options = [];

    if (
      dataProfile &&
      dataProfile.data &&
      dataProfile.data.formValues &&
      dataProfile.data.formValues.roles &&
      dataProfile.data.formValues.roles.length > 0
    ) {
      dataProfile.data.formValues.roles.map((role, key) =>
        options.push({
          key: key,
          value: role.id,
          label: role.name,
        })
      );
    } else {
      options.push({
        value: "empty",
        label: t("No matching records found"),
        isDisabled: true,
      });
    }

    return options;
  };

  const handleCreateProfile = () => {
    if (!idProfile) {
      dispatch(
        createProfile({
          ...newProfileValues,
        })
      );
    }
  };

  const handleEditProfile = () => {
    if (idProfile && newProfileValues) {
      dispatch(editProfile(newProfileValues, idProfile));
    }
  };

  useEffect(() => {
    dispatch(getProfile(idProfile, true));
  }, [dispatch, idProfile]);

  useEffect(() => {
    if (dataProfile && dataProfile.data && dataProfile.data.profile) {
      setName(dataProfile.data.profile.name);
      setRole(dataProfile.data.profile.role_id);
      setDescription(dataProfile.data.profile.description);
    }
  }, [dispatch, dataProfile]);

  const showToast = useCallback(
    (type, message) => {
      toastr[type](message);
      return successProfile && <Redirect to="/profiles" />;
    },
    [successProfile]
  );

  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    onHidden: () => successProfile && history.push("/profiles"),
  };

  useEffect(() => {
    if (successProfile && dataProfile) {
      showToast(
        "success",
        (dataProfile && dataProfile.message && dataProfile.message) ===
          "Profile created"
          ? t("Profile created")
          : (dataProfile && dataProfile.newProfileValues.message) ===
              "Profile updated" && t("Profile updated")
      );
    }
  }, [showToast, successProfile, dataProfile, t]);

  useEffect(() => {
    if (errorProfile) {
      showToast(
        "error",
        errorProfile === "Invalid data"
          ? t("Invalid data")
          : errorProfile === "Your session has expired"
          ? t("Your session has expired")
          : errorProfile ===
            "Sorry! the page you are looking for could not be found"
          ? t("Sorry! the page you are looking for could not be found")
          : errorProfile ===
              "Sorry! something went wrong, please contact our support team" &&
            t("Sorry! something went wrong, please contact our support team")
      );
      dispatch(resetProfiles());
    }
  }, [errorProfile, t, dispatch, showToast]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            mainPath="/profiles"
            path={"/profile"}
            title={t("Profiles")}
            breadcrumbItem={idProfile ? t("Edit profile") : t("Create profile")}
          />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  {loadingProfile && !dataProfile ? (
                    <div className="text-center">
                      <Spinner size="sm" animation="border" />
                    </div>
                  ) : (
                    <AvForm
                      onValidSubmit={
                        idProfile ? handleEditProfile : handleCreateProfile
                      }
                    >
                      <Row>
                        <Col sm="12">
                          <FormGroup>
                            <AvField
                              label={t("Name") + " *"}
                              id="name"
                              name="name"
                              type="text"
                              className="form-control"
                              placeholder={t("Enter profile name")}
                              onChange={(e) => {
                                setName(e.target.value);
                                setNewProfileValues({
                                  ...newProfileValues,
                                  name: e.target.value,
                                });
                              }}
                              value={name}
                              validate={{
                                required: {
                                  value: true,
                                  errorMessage: t("Required Field"),
                                },
                                maxLength: {
                                  value: 45,
                                  errorMessage: t("Invalid field"),
                                },
                                pattern: {
                                  value: "/^[A-Za-z áàâãéèêíïóôõöúç]*$/i", // only letters and space
                                  errorMessage: t(
                                    "Your name must be composed only with letter and space"
                                  ),
                                },
                              }}
                            />
                          </FormGroup>
                          <FormGroup>
                            <AvField
                              name="role"
                              className="form-control"
                              type="select"
                              label={t("Permission type") + " *"}
                              onChange={(e) => {
                                setRole(e.target.value);
                                setNewProfileValues({
                                  ...newProfileValues,
                                  role_id: e.target.value,
                                });
                              }}
                              value={role}
                              validate={{
                                required: {
                                  value: true,
                                  errorMessage: t("Required Field"),
                                },
                              }}
                            >
                              <option value="" disabled>
                                {t("Select")}
                              </option>
                              {optionsRole().map((profile, key) => (
                                <option
                                  key={key}
                                  value={profile.value}
                                  disabled={profile.isDisabled}
                                >
                                  {profile.label}
                                </option>
                              ))}
                            </AvField>
                          </FormGroup>
                          <FormGroup>
                            <AvField
                              id="description"
                              name="description"
                              type="textarea"
                              label={t("Description") + " *"}
                              placeholder={t(
                                "Briefly describe creating a new profile"
                              )}
                              className="form-control"
                              rows="3"
                              value={description}
                              onChange={textareachange}
                              validate={{
                                required: {
                                  errorMessage: t("Required Field"),
                                },
                                minLength: {
                                  value: 10,
                                  errorMessage: t(
                                    "Description must be at least 10 characters long"
                                  ),
                                },
                                maxLength: {
                                  value: 255,
                                },
                              }}
                            />
                            {textAreaBadge ? (
                              <span className="badgecount badge badge-success">
                                {" "}
                                {textCount} / 255{" "}
                              </span>
                            ) : null}
                          </FormGroup>
                        </Col>
                      </Row>

                      <Button
                        type="submit"
                        color="primary"
                        className="mr-1 waves-effect waves-light"
                        style={{ minWidth: "100px" }}
                      >
                        {loadingProfile ? (
                          <Spinner
                            size="sm"
                            animation="border"
                            style={{
                              height: "19px",
                              width: "19px",
                            }}
                          />
                        ) : (
                          t("Confirm")
                        )}
                      </Button>
                      <Link to="/profiles">
                        {" "}
                        <Button
                          type="button"
                          color="secondary"
                          className="waves-effect btn-dark"
                        >
                          {t("Cancel")}
                        </Button>
                      </Link>
                    </AvForm>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(NewProfile);
